import { useState, useEffect } from 'react';
import { supabase, createAdminUser } from '../lib/supabase';
import { Input, Btn, Loader } from '../components/UI';

export default function SetupPage({ onDone }) {
  const [exists, setExists]   = useState(false);
  const [checking, setChecking] = useState(true);
  const [login, setLogin]     = useState('admin');
  const [name, setName]       = useState('');
  const [msg, setMsg]         = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let done = false;
    // Никогда не зависаем на этом экране: при ошибке/таймауте считаем, что админ
    // уже есть (боевая база), и пропускаем в логин, а не показываем пустой экран.
    const finish = (adminExists) => { if (done) return; done = true; setExists(adminExists); setChecking(false); };
    supabase.from('users').select('id').eq('role','admin').limit(1)
      .then(({ data, error }) => { finish(error ? true : (data?.length > 0)); })
      .catch(() => finish(true));
    const t = setTimeout(() => finish(true), 6000);
    return () => clearTimeout(t);
  }, []);

  async function handleCreate(e) {
    e.preventDefault();
    if (!login || !name) { setMsg('Заполните все поля'); return; }
    setLoading(true); setMsg('');
    try {
      await createAdminUser({ login, full_name: name });
      setMsg('✓ Администратор создан! Войдите с этим кодом.');
      setTimeout(onDone, 2000);
    } catch (err) {
      setMsg('Ошибка: ' + err.message);
    } finally {
      setLoading(false);
    }
  }

  if (checking) return <Loader text="Инициализация..." />;
  if (exists) { onDone(); return null; }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1F3864 0%, #2E75B6 100%)', padding: 24,
    }}>
      <div style={{ background: 'white', borderRadius: 16, padding: '40px 32px', width: '100%', maxWidth: 360, boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>⚙️</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1F3864' }}>Первый запуск</div>
          <div style={{ fontSize: 13, color: '#718096', marginTop: 6 }}>Создайте аккаунт администратора</div>
        </div>
        <form onSubmit={handleCreate}>
          <Input label="Ваше ФИО" value={name} onChange={setName} placeholder="Кукшинский Максим" />
          <Input label="Код для входа" value={login} onChange={setLogin} placeholder="admin" />
          {msg && <div style={{ fontSize: 12, color: msg.startsWith('✓') ? '#276221' : '#9C0006', marginBottom: 12 }}>{msg}</div>}
          <Btn size="full" disabled={loading}>{loading ? 'Создание...' : 'Создать и войти'}</Btn>
        </form>
      </div>
    </div>
  );
}
